<template>
  <div id="search-form">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row mb-3">
        <fieldset class="search col-md-3">
          <legend>{{$t('form.search.legend')}}</legend>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="result col-md-9">
          <legend>{{$t('form.result.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
            <div class="col-md-6 offset-md-3">
              <ncs-matching-expressions-group-selector/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row mb-3">
        <fieldset class="sensibility col-md-3">
          <legend>{{$t('form.sensibility.legend')}}</legend>
          <ncs-global-option-checkbox name="case" :value="false"/>
        </fieldset>
        <fieldset class="filters col-md-9">
          <legend>{{$t('form.filters.legend')}}</legend>
          <div class="row">
            <div class="col-md-4">
              <ncs-select field="ncs_documents.student"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.course" operator="eq_any"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.level"/>
            </div>
            <div class="col-md-4">
              <slider-filter field="ncs_documents.age"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.sex"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.parents_origin" operator="array_contains_element"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.mother_tongue"/>
            </div>
            <div class="col-md-4">
              <slider-filter field="ncs_documents.age_studying_was_started"/>
            </div>
            <div class="col-md-4">
              <slider-filter field="ncs_documents.months_abroad"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.contacts"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.studies"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.topic"/>
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.text_type"/>
            </div>
            <div class="col-md-4">
              <ncs-multi-select field="ncs_documents.task_type" operator="eq_any" />
            </div>
            <div class="col-md-4">
              <ncs-select field="ncs_documents.other_languages" operator="array_contains_element"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end mt-3">
        <ncs-download-button/>
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result>
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <ncs-kwic-result/>
      <ncs-matching-expressions-result/>
      <ncs-context-result/>
      <tasks-result/>
      <task-result/>
    </ncs-result>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import Ncs from 'ncs'
  import SliderFilter from './SliderFilter'
  import TasksResult from './TasksResult'
  import TaskResult from './TaskResult'

  export default {
    extends: Ncs.defaultComponents.NcsForm,
    components: {SliderFilter, TasksResult, TaskResult},
    computed: mapState({
      resultType: s => s.api.resultType
    })
  }
</script>
<style lang="scss">
  @import "../scss/variables";

  legend {
    color: $primary;
    border-bottom: 1px solid $primary;
    font-size: 14px;
    margin-bottom: 5px;
  }

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 0.25rem;
  }
</style>
